<template>
  <div>
    <div class="relative no-headers">
      <el-dialog
        :visible.sync="centerDialogVisible"
        width="50%"
        @Close="CloseDialog"
      >
        <div class="">
          <div
            v-if="album.hasOwnProperty('images') && album.images.length != 0"
          >
            <swiper
              class="swiper"
              :options="swiperOptions2"
              ref="dialogSwip"
              :key="dialogSwipKey"
              :initial-slide="swiperIndex"
            >
              <swiper-slide v-for="(item, i) in images" :key="i">
                <img
                  :src="`${$imageURL}/` + item"
                  alt="img"
                  class="w-full h-400 cursor-pointer object-cover"
                />
              </swiper-slide>
              <div class="swiper-button-prev gallery" slot="button-prev"></div>
              <div class="swiper-button-next gallery" slot="button-next"></div>
            </swiper>
          </div>
          <div v-else>No Album</div>
        </div>
      </el-dialog>
      <div>
        <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design2 mob-hidden">
          <img
            src="../../../../assets/images/bg-des/bgd2.svg"
            alt="bg-polygon"
            class=""
          />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="../../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="flex justify-end relative h-95per">
          <img
            src="../../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="h-640px md-h-440px sm-h-578px bg-white"
          />
        </div>
        <div
          class="lg:px-20 md:px-10 px-5 w-full lg:flex md:flex items-center lg:gap-10 md:gap-10 absolute top-32"
        >
          <div class="lg:w-1/2 md:w-1/2 w-full">
            <div class="">
              <p
                class="font-semibold fsize36 md-fsize25 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full w-5/6"
              >
                {{ album.eventName.title }}
              </p>
              <div class="mt-2">
                <p
                  class="fsize18 md-fsize18 sm-fsize14 font-normal lh40px sm-lh20"
                >
                  {{ album.albumDescription }}
                </p>
                <p
                  class="fsize18 md-fsize18 sm-fsize14 font-normal lh40px sm-lh20"
                >
                  <span class="font-semibold"> Date: </span
                  >{{ getDate(album.eventName.date).split(",")[0] }}
                </p>
                <p
                  class="fsize18 md-fsize18 sm-fsize14 font-normal lh40px sm-lh20"
                >
                  <!-- <span class="font-semibold">Time: </span>
                  {{ album.eventName.time }} -->
                </p>
              </div>
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:mt-0 md:mt-0 mt-5">
            <img
              v-if="album.images.length === 0"
              src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
              alt="img"
              class="w-full lg:h-96 md:h-72 h-64 rounded-lg object-cover"
            />
            <img
              v-else
              :src="`${$imageURL}/` + album.images[swiperIndex]"
              alt="img"
              class="w-full lg:h-96 md:h-80 h-72 rounded-lg object-cover md:block lg:block hidden"
            />
          </div>
        </div>
      </div>
      <div class="lg:px-20 md:px-10 px-5 gap-3">
        <div v-if="album.hasOwnProperty('images') && album.images.length != 0">
          <swiper
            class="swiper lg:mt-10 md:mt-10 mt-8"
            :options="swiperOptions"
          >
            <swiper-slide v-for="(item, i) in album.images" :key="`${i}${i}`">
              <img
                v-if="item != ''"
                :src="`${$imageURL}/` + item"
                alt="img"
                class="w-full h-36 rounded-lg cursor-pointer"
                @click="handleSwiperImage(i)"
              />
              <!-- @click="changeIndex(i)" -->
              <img
                v-else
                src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
                alt="img"
                class="w-full h-36 rounded-lg cursor-pointer"
              />
              <!-- @click="changeIndex(i)" -->
            </swiper-slide>
            <div class="swiper-button-prev gallery" slot="button-prev"></div>
            <!-- @click="incrementIndex()" -->
            <div class="swiper-button-next gallery" slot="button-next"></div>
          </swiper>
        </div>
        <div v-else>No Album</div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      centerDialogVisible: false,
      dialogSwipKey: 87524, // random key
      swiperIndex: 0,
      swiperOptions: {
        slidesPerView: 10,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1600: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          1240: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          856: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
        },
      },
      swiperOptions2: {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1600: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          1240: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          856: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        },
      },
      album: {},
      images: [],
    };
  },

  computed: {
    ...mapState("ffc", ["selected_event"]),
  },
  methods: {
    CloseDialog() {
      this.centerDialogVisible = false;
    },
    handleSwiperImage(i) {
      this.dialogSwipKey = Math.random().toFixed(4);
      this.images = [
        ...this.album.images.slice(i),
        ...this.album.images.slice(0, i),
      ];

      this.swiperIndex = i;

      this.centerDialogVisible = true;
    },

    getDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm a");
    },

    async getAlbumData(galleryId) {
      const { data } = await this.$store.dispatch(
        "gallery/getGalleryById",
        galleryId
      );
      return data.album;
    },
    async init() {
      const galleryId = this.$route.params;
      this.album = await this.getAlbumData(galleryId);
    },
  },
  async mounted() {
    this.init();
  },
};
</script>

<style>
.gallery.swiper-button-next,
.swiper-button-prev {
  height: 43px !important;
  top: 55% !important;
}
.no-headers .el-dialog__body {
  padding: 0px !important;
}
.no-headers .el-dialog__header {
  padding: 0px !important;
}
</style>
